<mat-card appearance="outlined">
  <h1 class="mat-headline-4 smallmargin">Cheatsheets</h1>
  <p class="mat-body">
    This page has moved to the <a href="https://avrae.readthedocs.io/en/stable/" target="_blank"
                                  rel="noopener noreferrer">new Cheatsheet site.</a>
  </p>
</mat-card>
